export const PERSONAL_INFORMATION_PATH = '/personal-details/personal-information';
export const EDIT_MAILING_ADDRESS = '/personal-details/edit/mailing-address';
export const EDIT_DELIVERY_ADDRESS = '/personal-details/edit/delivery-address';
export const EDIT_HOME_ADDRESS = '/personal-details/edit/home-address';
export const EDIT_PASSWORD_PATH = '/personal-details/edit-password';
export const ADD_PHONE_NUMBER = '/personal-details/add/phone-number';
